import React from 'react';
import MobileFilters from './MobileFilters';
import RequestData from './RequestData';
import TitleLogo from './TitleLogo';
/** @jsxImportSource @emotion/react */
import 'twin.macro';

const Header = () => (
  <header tw="fixed bg-white/80 z-[1002] flex justify-between items-center w-full p-[1rem 4rem] md:p-[1rem 2rem] sm:p-[1rem] sm:bg-blue-50 border-b-[0.1rem] border-b-blue-800 backdrop-blur-md">
    <TitleLogo />
    <RequestData />
    <MobileFilters />
  </header>
);

export default Header;
